import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import './QuizPage.css'; // Ensure your CSS file contains card-related styles

const QuizPage = () => {
  const { courseId, quizId } = useParams();
  const location = useLocation();
  const [userId, setUserId] = useState(null);
  const [quizData, setQuizData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    if (location.state && location.state.userId) {
      setUserId(location.state.userId);
      console.log('Received userId:', location.state.userId);
    }
  }, [location.state]);

  useEffect(() => {
    const fetchQuizData = async () => {
      try {
        const response = await fetch(
          `https://schoolofservice.co.za/backend/fetch_quiz.php?courseId=${courseId}&quizId=${quizId}&userId=${userId || ''}`
        );
        const data = await response.json();
        console.log('Fetched quiz data:', data);

        if (data.status === 'success') {
          setQuizData(data);
        } else {
          setError(data.message || 'Failed to load quiz data.');
        }
      } catch (err) {
        setError(err.message || 'An error occurred while fetching quiz data.');
      } finally {
        setIsLoading(false);
      }
    };

    if (userId) {
      fetchQuizData();
    }
  }, [courseId, quizId, userId]);

  const handleAnswerChange = (questionId, optionId, optionText) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: {
        questionId,
        optionId,
        optionText,
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const submissionData = {
      userID: userId || null,
      coursesID: courseId,
      quizId: quizId,
      answers: Object.keys(answers).map((questionId) => {
        const { optionId, optionText, questionId: qId } = answers[questionId];
        return {
          questionId: qId,
          answerData: [
            {
              optionId,
              optionText,
            },
          ],
        };
      }),
    };

    console.log('Submission Data:', submissionData);

    try {
      const response = await fetch('https://schoolofservice.co.za/backend/submit_quiz.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(submissionData),
      });

      const data = await response.json();
      console.log('Backend Response:', data);

      if (data.status === 'success') {
        alert('Your answers have been submitted successfully!');
      } else {
        alert(`Failed to submit your answers. Reason: ${data.message || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('Error submitting quiz answers:', err);
      alert('An error occurred while submitting your answers.');
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!quizData || !Array.isArray(quizData.questions) || quizData.questions.length === 0) {
    return <div>No quiz data available.</div>;
  }

  return (
    <div className="quiz-container">
      <h1 className="quiz-title">{quizData.quiz.quizTitle}</h1>
      {userId && <p className="quiz-welcome">Welcome, to your Quiz Test</p>}
      <form onSubmit={handleSubmit}>
        {quizData.questions.map((question) => (
          <div className="quiz-card" key={question.questionId}>
            <div className="quiz-question">
              <p>{question.questionText}</p>
            </div>
            <div className="quiz-options">
              {question.options.map((option) => (
                <label key={option.optionId} className="quiz-option">
                  <input
                    type={question.questionType === 'checkbox' ? 'checkbox' : 'radio'}
                    name={question.questionId}
                    value={option.optionId}
                    checked={answers[question.questionId]?.optionId === option.optionId}
                    onChange={() =>
                      handleAnswerChange(question.questionId, option.optionId, option.optionText)
                    }
                  />
                  {option.optionText}
                </label>
              ))}
            </div>
          </div>
        ))}
        <button type="submit" className="submit-button">
          Submit Quiz
        </button>
      </form>
    </div>
  );
};

export default QuizPage;
